import React from "react"
import StaticPageContainer from "../../../containers/misc/StaticPageContainer"

export default props => <StaticPageContainer slug="terms" />
